import React from 'react';
import { deleteGuest } from '../actions/fieldsActions';
import { useTranslation } from 'react-i18next';
import { ConfirmDialog } from 'primereact/confirmdialog';
import { deleteField } from '../actions/fieldsActions';

export const ModalDeleteField = ({ isOpen, onClose, fieldId, userId, setTrigger }) => {
    const { t } = useTranslation();
    const handleDeleteGuest = async (fieldId, userId) => {
        try {
            const response = await deleteGuest(fieldId, userId);
            if (response.status === 200) {
                setTrigger(prev => !prev);
            } else {
                console.error('Error deleting user:', response.statusText);
            }
        } catch (error) {
            console.error('Error deleting user:', error);
        }
    };

    if (!isOpen) return null;

    return (
        <div onClick={(e) => e.stopPropagation()}>
        <ConfirmDialog
            className="w-11 desktop-max-width border-round-2xl"
            visible={isOpen}
            message={t('field.delete_field_message')}
            header={t('field.adverse')}
            acceptLabel={t('field_card.delete')}
            acceptClassName="bg-primary"
            rejectClassName="p-confirm-dialog-reject p-button-text p-button p-component"
            rejectLabel={t('settings.cancel')}
            //rejectClassName="hidden"
            defaultFocus="none"
            focusOnShow={false}
            onClick={e => e.stopPropagation()}
            onHide={onClose}
            accept={async () => {
                await deleteField(fieldId);
                onClose();
                window.location.reload();
            }}
            pt={{
                header: { className: 'border-round-top-2xl' },
                footer: {className: 'border-round-bottom-2xl'}
            }}
        />
        </div>
    );
};
